// Styles
import './AdminInsetBox.css';

// Types
import mixins from "vue-typed-mixins";
// Main
const AdminInsetBox = mixins().extend({
  render() {
    var _this$$scopedSlots$de, _this$$scopedSlots;
    const h = arguments[0];
    return h("div", {
      "class": 'admin-inset-box'
    }, [(_this$$scopedSlots$de = (_this$$scopedSlots = this.$scopedSlots).default) === null || _this$$scopedSlots$de === void 0 ? void 0 : _this$$scopedSlots$de.call(_this$$scopedSlots, {})]);
  }
});
export default AdminInsetBox;